declare const BASE_URL: string;

declare const GLOBAL_CONFIG: { BASE_URL: string }

export const baseUrl = (() => {
    let baseUrl = BASE_URL
    if (! BASE_URL) {
        baseUrl = GLOBAL_CONFIG.BASE_URL;
    }
    if (! baseUrl) {
        baseUrl = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/api/`;
    }

    return baseUrl
})();
